export const LoadingComponent = ({ ended }: { ended: boolean }) => {
	return (
		<>
			<svg id="loading-logo" className={ended ? "loading-screen-complete" : ""} viewBox="0 0 242 42">
				<path
					id="loading-path"
					className={ended ? "" : "loading-screen-path"}
					style={{ fill: `${ended ? "#FFF" : ""}` }}
					d="M77.4049 27.2102C77.4049 34.2043 71.83 39.8625 64.9687 39.8625L47.133 39.8428V30.943H64.9687C67.0154 30.943 68.6722 29.2534 68.6722 27.1906C68.6722 25.1277 67.0154 23.4381 64.9687 23.4381H58.5361C52.2205 23.4381 47.094 18.2318 47.094 11.8075C47.094 5.3831 52.2205 0.176817 58.5166 0.176817H77.3854V9.09627H58.5361C57.0547 9.09627 55.8461 10.3143 55.8461 11.8271C55.8461 13.3202 57.0352 14.558 58.5361 14.558H64.9882C71.83 14.5383 77.4049 20.2161 77.4049 27.2102ZM80.9331 9.07662H96.8C94.3049 12.5737 92.8235 16.8959 92.8235 21.5521V39.8625H102.433L102.453 20.334C102.472 14.1847 107.365 9.1945 113.388 9.1945L120.503 9.17485V9.05697V0.275049V0.157171H80.9331V9.07662ZM203.756 0.275049H203.561V9.17485L204.106 9.1945C210.149 9.21414 215.042 14.1847 215.042 20.334L215.061 39.8625H224.671V21.5521C224.671 9.78389 215.295 0.275049 203.756 0.275049ZM221.084 0.275049H220.89V9.17485L221.435 9.1945C227.478 9.21414 232.371 14.1847 232.371 20.334L232.39 39.8625H242V21.5521C242.019 9.78389 232.663 0.275049 221.084 0.275049ZM195.666 10.6876C195.666 4.8723 191.027 0.137525 185.296 0.137525H165.18V9.03733H184.205C184.653 9.03733 185.043 9.21415 185.335 9.50884C185.628 9.80354 185.803 10.2161 185.822 10.668C185.822 11.5717 185.101 12.3183 184.205 12.3183H170.501V21.2181H178.357C182.548 21.2181 185.978 24.6758 185.978 28.9391L186.056 39.8232H195.666V28.7623C195.666 24.8919 194.36 21.3556 192.177 18.5462C192.333 18.4283 192.489 18.2908 192.625 18.1336C194.516 16.2279 195.666 13.5953 195.666 10.6876ZM162.685 20C162.685 31.0413 153.874 40 143.036 40C132.179 40 123.388 31.0413 123.388 20C123.368 8.95874 132.179 0 143.036 0C153.874 0 162.685 8.95874 162.685 20ZM154.167 20C154.167 13.2416 149.176 7.76031 143.017 7.76031C136.857 7.76031 131.867 13.2416 131.867 20C131.867 26.7583 136.857 32.2397 143.017 32.2397C149.176 32.2397 154.167 26.7583 154.167 20ZM8.90809 19.9804C8.90809 26.169 13.8982 31.1788 20.0188 31.1788H39.1605V39.7642H18.8493C8.03093 39.7839 0 30.9037 0 19.9804C0 9.05697 8.03093 0.196464 18.8493 0.196464H28.0693C34.8722 0.196464 40.4081 5.77603 40.4081 12.6326C40.4081 19.4892 34.8722 25.0688 28.0693 25.0688C20.1163 25.0688 13.6448 18.5855 13.5668 10.5894C10.526 12.5933 8.90809 16.0511 8.90809 19.9804ZM22.4749 10.4715C22.4749 13.7917 24.3852 16.5029 27.6794 16.5029C29.7846 16.5029 31.5194 14.7741 31.5194 12.6326C31.5194 10.4912 29.8041 8.76228 27.6794 8.76228H22.4749V10.4715Z"
					fill="url(#step1)"
				/>
				<defs>
					<linearGradient id="step1" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step2" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="5%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step3" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="10%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step4" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="15%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step5" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="20%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step6" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="25%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step7" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="30%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step8" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="35%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step9" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="40%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step10" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="45%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step11" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="50%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step12" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="55%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step13" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="60%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step14" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="65%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step15" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="70%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step16" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="75%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step17" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="80%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step18" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="85%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step19" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="90%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step20" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="95%" stopColor="#AB00C7" />
						<stop offset="100%" stopColor="#0075FF" />
					</linearGradient>

					<linearGradient id="step21" x1="1.17425" y1="41.809" x2="242" y2="41.809" gradientUnits="userSpaceOnUse">
						<stop offset="0%" stopColor="#0075FF" />
						<stop offset="100%" stopColor="#AB00C7" />
					</linearGradient>
				</defs>
			</svg>
		</>
	);
};
